"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getStackBarChartOptions = exports.getChartOptions = void 0;
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var MAX_CHART_HEIGHT = 100000;
function getChartHeight(numOfBars) {
    var base = 60;
    return Math.min(MAX_CHART_HEIGHT, numOfBars * base + 300);
}
function generateSeries(dataRows, legends, zIndex, stack) {
    if (zIndex === void 0) { zIndex = 6; }
    if (stack === void 0) { stack = 'main'; }
    var utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DEFAULT);
    var series = [];
    var _loop_1 = function (index) {
        var _a = legends[index], tag = _a.tag, color = _a.color, label = _a.label;
        var seriesData = dataRows.filter(function (item) {
            return item.colorTag === tag && typeof item.y !== 'undefined';
        });
        if (seriesData.length > 0) {
            series.push({
                name: label ? label : tag,
                color: color,
                zIndex: zIndex,
                data: seriesData,
                stack: stack
            });
        }
    };
    for (var index = 0; index < legends.length; index++) {
        _loop_1(index);
    }
    // for (let legend of legends) {
    //     const tagKey = legend['tag'];
    //     const tagColor = utilsService.makeColor();
    //     const seriesData = dataRows.filter((item) => {
    //         return item.colorTag === tagKey && typeof item.y !== 'undefined';
    //     });
    //     if (seriesData.length > 0) {
    //         series.push({
    //             name: tagKey,
    //             color: tagColor,
    //             zIndex: zIndex,
    //             data: seriesData,
    //             stack
    //         });
    //     }
    // }
    return series;
}
function generateStackedSeries(dataRows, drillDowns, legends, zIndex, stack) {
    if (zIndex === void 0) { zIndex = 6; }
    if (stack === void 0) { stack = 'main'; }
    var categories = dataRows.map(function (row) { return row.name; });
    var newDrillDownSeriesMap = {};
    var series = legends.map(function (legend) {
        var label = legend.label, color = legend.color, tag = legend.tag;
        label = label !== null && label !== void 0 ? label : tag;
        return {
            name: label,
            color: color,
            zIndex: zIndex,
            data: dataRows.map(function (row, index) {
                var drillDownId = stack + "_" + label + "_" + index;
                newDrillDownSeriesMap[drillDownId] = {
                    name: row.name + " - " + label,
                    id: drillDownId,
                    data: undefined,
                    stack: stack
                };
                return { name: row.name, y: 0, drilldown: drillDownId };
            }),
            stack: stack
        };
    });
    drillDowns.forEach(function (dd) {
        var index = categories.indexOf(dd.name);
        dd.data.forEach(function (d, dIndex) {
            series.filter(function (s) { return s.name === d.colorTag; }).forEach(function (s) {
                s.data[index].y += d.y;
                var drillDownId = s.data[index].drilldown;
                var drillDownSeries = newDrillDownSeriesMap[drillDownId];
                if (!drillDownSeries.data) {
                    drillDownSeries.data = dd.data.map(function (node) { return ({ name: node.name, y: 0 }); });
                }
                drillDownSeries.data[dIndex] = d;
                // If no data shows up for a series, the series will be removed.
                s.keep = true;
            });
        });
    });
    return [
        series.filter(function (s) { return s.keep; }),
        Object.values(newDrillDownSeriesMap).filter(function (d) { return d.data; }),
    ];
}
function assignXValue(mainSeriesData, siblingSeriesData) {
    var totalBars = mainSeriesData.length;
    mainSeriesData.forEach(function (row, index) {
        row.x = index;
    });
    if (siblingSeriesData && siblingSeriesData.length > 0) {
        var positionFix_1 = 0.05;
        mainSeriesData.forEach(function (row, index) {
            for (var _i = 0, siblingSeriesData_1 = siblingSeriesData; _i < siblingSeriesData_1.length; _i++) {
                var sibRow = siblingSeriesData_1[_i];
                if (!sibRow.x && sibRow.name === row.name) {
                    sibRow.x = index + positionFix_1;
                    break;
                }
            }
        });
        siblingSeriesData.filter(function (row) { return !row.x; }).forEach(function (row) {
            var rowCopy = __assign(__assign({}, row), { x: totalBars, y: 0 });
            siblingSeriesData.push(rowCopy);
            row.x = totalBars + positionFix_1;
            totalBars += 1;
        });
    }
    return totalBars;
}
function getNumberOfBars(mainSeriesData, siblingSeriesData) {
    if (siblingSeriesData && siblingSeriesData.length > 0) {
        var barSet_1 = new Set();
        mainSeriesData.forEach(function (row) {
            barSet_1.add(row.name);
        });
        siblingSeriesData.forEach(function (row) {
            barSet_1.add(row.name);
        });
        return barSet_1.size;
    }
    return mainSeriesData.length;
}
function generateChartOptionts(graph, options, chartHeight, series, drilldown, chartType) {
    var chartTitle = options.chartTitle, settings = options.settings, timestamp = options.timestamp;
    return {
        chart: {
            renderTo: 'chartContainer',
            type: chartType,
            width: 650,
            height: chartHeight,
            zoomType: 'xy',
            marginRight: 50
        },
        credits: {
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        xAxis: {
            type: 'category'
        },
        yAxis: [{
                min: graph.minValue,
                max: graph.maxValue,
                title: {
                    text: graph.unit
                }
            }],
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                return "<b>" + this.key + "</b><br /><i>" + this.series.name + "</i>: " + this.y.toFixed(settings.decimals);
            }
        },
        plotOptions: {
            series: {
                turboThreshold: 0,
                // pointWidth: 20,
                pointPadding: 0.16,
                stacking: 'normal'
            }
        },
        lang: {
            drillUpText: '◁ Back to {pointOptions.name}'
        },
        series: series,
        drilldown: {
            allowPointDrilldown: false,
            series: drilldown
        }
    };
}
function getChartOptions(graph, options) {
    var chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp, chartType = options.chartType;
    var mainSeriesData = graph.mainRows.sort(function (a, b) { return b.y - a.y; });
    var siblingSeriesData = (graph.siblingRows || []).sort(function (a, b) { return b.y - a.y; });
    var totalBars = assignXValue(mainSeriesData, siblingSeriesData);
    var chartHeight = getChartHeight(totalBars);
    var series = generateSeries(mainSeriesData, legends, 6, 'main');
    var drilldown = graph.mainDrillDown.map(function (item) {
        item.stack = 'main';
        return item;
    });
    if (siblingSeriesData.length > 0) {
        var siblingSeries = generateSeries(siblingSeriesData, siblingLegends, 5, 'sib');
        series = series.concat(siblingSeries);
        drilldown = drilldown.concat(graph.siblingDrillDown.map(function (item) {
            item.stack = 'sib';
            return item;
        }));
    }
    return generateChartOptionts(graph, options, chartHeight, series, drilldown, chartType);
}
exports.getChartOptions = getChartOptions;
function getStackBarChartOptions(graph, options) {
    var chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp, chartType = options.chartType;
    var mainSeriesData = graph.mainRows.sort(function (a, b) { return b.y - a.y; });
    var siblingSeriesData = (graph.siblingRows || []).sort(function (a, b) { return b.y - a.y; });
    var totalBars = getNumberOfBars(mainSeriesData, siblingSeriesData);
    var chartHeight = getChartHeight(totalBars);
    var _b = generateStackedSeries(mainSeriesData, graph.mainDrillDown, legends, 6, 'main'), series = _b[0], drillDown = _b[1];
    if (siblingSeriesData.length > 0) {
        var _c = generateStackedSeries(siblingSeriesData, graph.siblingDrillDown, siblingLegends, 5, 'sib'), siblingSeries = _c[0], siblingDrillDown = _c[1];
        series = series.concat(siblingSeries);
        drillDown = drillDown.concat(siblingDrillDown);
    }
    return generateChartOptionts(graph, options, chartHeight, series, drillDown, chartType);
}
exports.getStackBarChartOptions = getStackBarChartOptions;
//# sourceMappingURL=compare-value.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/compare-value2/compare-value.chart.js